import axios from 'axios'
import router from '../../router/index'

export default {
  namespaced: true,
  state() {
    return {
      file: '',
    }
  },
  getters: {
  },
  mutations: {
    SAVE_FILE(state, data) {
      state.file = data;
    },
  },
  actions: {
    async uploadFile({state,commit,dispatch, rootState}, data) {
      let url = process.env.VUE_APP_URL + 'files/upload';
      let res;
      await axios({
        method: 'post',
        url: url,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then((data) => {
        //save token
        res = data.data
        commit('SAVE_FILE', data.data);
      }).catch((e) => {
        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return res;
    },
    async removeFile({state,commit,dispatch, rootState}, data) {
      let url = process.env.VUE_APP_URL + 'files/delete';
      let res;
      await axios({
        method: 'post',
        url: url,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((data) => {
        //save token
        res = data.data
      }).catch((e) => {
        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      });
      return res;
    },
  }
}
